import React from 'react';

import {useMediaQuery} from '../hooks/useMediaQuery';
import styles from './styles/about-page.module.css';

import About01 from '../components/about01/About01';
import About02 from '../components/about02/About02';
import About03 from '../components/about03/About03';
import About04 from '../components/about04/About04';
import About05 from '../components/about05/About05';
import About06 from '../components/about06/About06';

export default function AboutPage() {
    const mobileSmall = useMediaQuery('(max-width: 480px)');
    const mobileMedium = useMediaQuery('(min-width: 481px) and (max-width: 768px)');

    const getSectionHeight = () => {
      if (mobileSmall) return '403px';
      if (mobileMedium) return '672px';
      if (mobileMedium) return '784px';

      return 'calc(100vh - 62px)';
    };

    return (
      <div>
        <section 
          className={styles.section01}
          style={{ height: getSectionHeight() }}
        >
          <About01 />
        </section>
        <section className={styles.section02}>
          <About02 />
          <About03 />
          <About04 />
          <About05 />
          <About06 />
        </section>
      </div>
    );
}
